// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"178":"item","596":"404","680":"monster"}[chunkId] || chunkId) + "." + {"178":"83f77575","591":"d74bb950","596":"b97a71bd","680":"ee559831"}[chunkId] + ".js";
};